module.exports = __webpack_public_path__ + "img/icon-plus-grey.d69cce76.svg";